import * as types from './mutation-types'

export default {
  clearErrors ({ commit }) {
    commit(types.SET_ERRORS, { errors: null })
  },
  clearNotification ({ commit }) {
    commit(types.SET_NOTIFICATION, { notification: null })
  },
  setErrors ({ commit }, payload) {
    commit(types.SET_ERRORS, payload)
  },
  setIsSidebarOpen ({ commit }, payload) {
    commit(types.SET_IS_SIDEBAR_OPEN, payload)
  },
  setNotification ({ commit }, payload) {
    commit(types.SET_NOTIFICATION, payload)
  },
  openChatWabee ({ commit }) {
    commit(types.SET_SHOW_CHAT_WABEE, true)
  },
  closeChatWabee ({ commit }) {
    commit(types.SET_SHOW_CHAT_WABEE, false)
  }
}
